export const URI_MASTER_EVENTS = '/';
export const URI_EVENT = 'event';
